import * as React from 'react';
import { createContext, useContext } from 'react';

import { compose } from 'recompose';

import type { UserPermissionsPublicAPI } from 'bundles/user-permissions/src/utils/types';
import { withUserPermissions } from 'bundles/user-permissions/src/withUserPermissions';

export interface UserPermissionsDataContextValue {
  userPermissions?: UserPermissionsPublicAPI;
}

interface PropsFromHOC {
  userPermissions?: UserPermissionsPublicAPI;
}

const INITIAL_CONTEXT_DATA: UserPermissionsDataContextValue = {
  userPermissions: undefined,
};

export const UserPermissionsDataContext = createContext<UserPermissionsDataContextValue>(INITIAL_CONTEXT_DATA);

type UseUserPermissionsData = () => UserPermissionsDataContextValue;

export const useUserPermissionsData: UseUserPermissionsData = () => useContext(UserPermissionsDataContext);

/**
 * Intended to replace the usage of the HOC withUserPermissions, should be used in pair with UserPermissions
 *
 * For example:
 * <UserPermissions>
 *   <ComponentA>
 * </UserPermissions>
 *
 * Inside componentA:
 * <UserPermissionsDataProvider>
 *   <ComponentB>
 * </UserPermissionsDataProvider>
 *
 * Inside componentB:
 * call useUserPermissionsData() to get the userPermissions data
 */
export const UserPermissionsDataProvider: React.LegacyFunctionComponentWithChildren<PropsFromHOC> = ({
  children,
  userPermissions,
}) => <UserPermissionsDataContext.Provider value={{ userPermissions }}>{children}</UserPermissionsDataContext.Provider>;

export default compose<PropsFromHOC, {}>(withUserPermissions())(UserPermissionsDataProvider);
